// Angular
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// CRUD
import { InterceptService } from '../../../core/_base/crud/';
// Module components
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthNoticeComponent } from './auth-notice/auth-notice.component';
// Auth
import { AuthGuard, } from '../../../core/auth';
import { WebformComponent } from '../webform/webform.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ThemeModule } from "../../theme/theme.module";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgOtpInputModule } from  'ng-otp-input';
// src/app/views/theme/theme.module.ts


const routes: Routes = [
	{
		path: '',
		component: AuthComponent,
		children: [
			// {
			// 	path: '',
			// 	redirectTo: 'login',
			// 	pathMatch: 'full',

			// }
			// {
			// 	path: 'login',
			// 	component: LoginComponent,
			// 	data: {returnUrl: window.location.pathname}
			// },
			// {
			// 	path: 'forgot-password',
			// 	component: ForgotPasswordComponent,
			// }
		]
	}
];


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule.forChild(routes),
		TranslateModule.forChild(),		
		MatButtonModule, 
		MatCheckboxModule, 
		MatFormFieldModule, 
		MatInputModule,
		ThemeModule,
		NgbModule,
		NgOtpInputModule	
	],
	providers: [
		InterceptService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: InterceptService,
			multi: true
		},
	],
	exports: [AuthComponent,RouterModule,LoginComponent,WebformComponent],
	declarations: [
		AuthComponent,
		LoginComponent,
		ForgotPasswordComponent,
		AuthNoticeComponent,
		WebformComponent
	]
})

export class AuthModule {
	static forRoot(): ModuleWithProviders<AuthModule> {
		return {
			ngModule: AuthModule,
			providers: [
				AuthGuard
			]
		};
	}
}